import React from 'react';
import T from 'i18n-react';
import Yup from 'yup';
import moment from 'moment';
import { isAbove18years } from '../../../utils/loaLawyerHelpers';

const validationSchema = props => {
  const errorMessage = (
    <div>
      <T.text tag="h3" text={{ key: 'errHeader' }} />
      <T.span text={{ key: 'errBody' }} />
    </div>
  );
  return Yup.lazy(values => {
    let shape;
    // generate preview - validate pax / guardian | PaxForm, GuardianForm
    const personValidationSchema = {
      firstName: Yup.string().trim().required(errorMessage),
      lastName: Yup.string().trim().required(errorMessage),
      birthDate: Yup.date().required(errorMessage),
      birthPlace: Yup.string().trim().required(errorMessage),
      street: Yup.string().trim().required(errorMessage),
      postalCode: Yup.string().trim().required(errorMessage),
      city: Yup.string().trim().required(errorMessage),
      country: Yup.string().required(errorMessage),
      profession: Yup.string().trim().required(errorMessage),
    };

    const minorValidationSchema = {
      firstName: Yup.string().trim().required(errorMessage),
      lastName: Yup.string().trim().required(errorMessage),
      birthDate: Yup.date()
        .required(errorMessage)
        .max(moment(Date.now()), T.translate('dateInvalid')),
      birthPlace: Yup.string().trim().required(errorMessage),
    };

    const guardianValidationSchema = {
      ...personValidationSchema,
      birthDate: Yup.date()
        .max(
          moment().subtract(18, 'years'),
          T.translate('guardianNotAdult'),
        )
        .required(errorMessage),
    };

    // generate pdf - validate t_c | PdfPreview
    const pdfValidationSchema = {
      termsAndConditions1: Yup.bool()
        .required(errorMessage)
        .oneOf([true], errorMessage),
      termsAndConditions2: Yup.bool()
        .required(errorMessage)
        .oneOf([true], errorMessage),
      termsAndConditions3: Yup.bool()
        .required(errorMessage)
        .oneOf([true], errorMessage),
      signedIn: Yup.string().trim()
        .matches(/[\D\s]+/)
        .required(errorMessage),
    };

    // sign document | SignDocument
    const signDocumentValidationSchema = {
      signDate: Yup.date().required(errorMessage),
      signPlace: Yup.string().required(errorMessage),
    };

    if (props.validatePax) {
      if (isAbove18years(values.birthDate)) {
        shape = personValidationSchema;
      } else {
        shape = minorValidationSchema;
      }
    }
    if (props.validateGuardian) {
      shape = guardianValidationSchema;
    }
    if (props.validateGeneratePdfForm) {
      shape = pdfValidationSchema;
    }
    if (props.validateSignDocumentForm) {
      shape = signDocumentValidationSchema;
    }
    return Yup.object().shape(shape);
  });
};

export default validationSchema;



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/Form/validationSchema.js